import { Grid, InputAdornment, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import PrintSelectCustomer from '../../../CustomerSellPopup/PrintSelectCustomer'
import SearchIcon from '@mui/icons-material/Search'
import { useMemo, useState } from 'react'
import CustomerAccountMainList from './CustomerAccountMainList'
import { CustomerAccountPaymentModel } from './CustomerAccountsPaymentMobile'

interface IProps {
    selectedCustomerId?: string
    customerAccounts: CustomerAccountPaymentModel[]
    onSelectCustomer: (id: string) => void
    onAssignToPayment: (id: string) => void
    isLoading?: boolean
}

function CustomerAccountsPaymentPanel({
    selectedCustomerId,
    customerAccounts,
    onSelectCustomer,
    onAssignToPayment,
    isLoading,
}: IProps) {
    const { t } = useTranslation()
    const [queryText, setQueryText] = useState('')

    const selectedCustomerAccount = useMemo(() => {
        return customerAccounts.find(
            (f) => f.customer?.customerID === selectedCustomerId && f.isActive,
        )
    }, [customerAccounts, selectedCustomerId])
    const filterCustomers = useMemo(
        () =>
            customerAccounts.filter((c) => {
                let f = c.customer
                if (!f) return false
                return (
                    f.email?.toLowerCase().includes(queryText.toLowerCase()) ||
                    f.familyName
                        ?.toLowerCase()
                        .includes(queryText.toLowerCase()) ||
                    f.givenName
                        ?.toLowerCase()
                        .includes(queryText.toLowerCase()) ||
                    f.preferredName
                        ?.toLowerCase()
                        .includes(queryText.toLowerCase())
                )
            }),
        [customerAccounts, queryText],
    )

    return (
        <Grid container spacing={2}>
            <Grid item xs={4} md={6} height={45}>
                {!selectedCustomerAccount ? (
                    'No Account'
                ) : (
                    <PrintSelectCustomer
                        selectCustomer={selectedCustomerAccount.customer}
                    />
                )}
            </Grid>
            <Grid item xs={12}>
                <TextField
                    placeholder={t(
                        'quick_sell.label.search_customer_with_accounts',
                    )}
                    value={queryText}
                    onChange={(e) => setQueryText(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    fullWidth={true}
                />
            </Grid>
            <Grid item xs={12}>
                <CustomerAccountMainList
                    customers={filterCustomers}
                    selectCustomerID={selectedCustomerId}
                    assignToOrder={(customerId: string) => {
                        onAssignToPayment(customerId)
                    }}
                    setSelectCustomer={onSelectCustomer}
                />
            </Grid>
        </Grid>
    )
}

export default CustomerAccountsPaymentPanel
